<template>
  <div class="container">
    <!-- 顶部 -->
    <img
      v-show="status == 0"
      src="//pic-cdn.bigdatajy.com/wenming/static/img/status01.png"
      alt=""
    />
    <img
      v-show="status == 1"
      src="//pic-cdn.bigdatajy.com/wenming/static/img/status02.png"
      alt=""
    />
    <img
      v-show="status == 2"
      src="//pic-cdn.bigdatajy.com/wenming/static/img/status03.png"
      alt=""
    />
    <img
      v-show="status == 3"
      src="//pic-cdn.bigdatajy.com/wenming/static/img/status04.png"
      alt=""
    />
    <div class="eventrule">
      <img
        src="//pic-cdn.bigdatajy.com/wenming/static/img/eventrule.png"
        alt=""
      />
      <p>活动规则</p>
    </div>
    <div class="font">
      <p>许愿人数：{{ top.wish_count }}</p>
      <p>浇水人数：{{ top.help_count }}</p>
      <p>心愿果实：{{ top.result_count }}</p>
    </div>
    <div class="flex bts">
      <div class="bt">
        <img src="//pic-cdn.bigdatajy.com/wenming/static/img/bt.png" alt="" />
        <p>“澄”就微心愿</p>
      </div>
      <!-- <div class="flex">
        <img class="right" style="margin-top:1vw;" src="../../static/img/xy.png" alt="" @click="linkto('/applywish')">
        <img class="right" style="margin-left: 10px;" src="../../static/img/js.png" alt="" @click="linkto('/wishlist')">
      </div> -->
    </div>
    <div class="block">
      <div>
        <img :src="member.img" class="tx" alt="" />
        <p style="font-weight: bold">{{ member.name }}</p>
      </div>
      <div @click="urlchange('/applywish')">
        <div class="cover">
          <img
            src="//pic-cdn.bigdatajy.com/wenming/static/img/01.png"
            alt=""
            class="centericon"
          />
        </div>
        <p>我要许愿</p>
      </div>
      <div @click="urlchange('/mywish')">
        <div class="cover">
          <img
            src="//pic-cdn.bigdatajy.com/wenming/static/img/02.png"
            alt=""
            class="centericon"
          />
        </div>
        <p>我的许愿</p>
      </div>
      <div @click="urlchange('/myjoin')">
        <div class="cover">
          <img
            src="//pic-cdn.bigdatajy.com/wenming/static/img/03.png"
            alt=""
            class="centericon"
          />
        </div>
        <p>我的参与</p>
      </div>
    </div>
    <form action="/">
      <van-search
        v-model="search"
        placeholder="请输入搜索关键词"
        @search="onSearch"
      />
    </form>
    <div class="tabcontainer">
      <van-list
        v-model="listloading"
        :finished="listfinished"
        finished-text="没有更多啦"
        :immediate-check="false"
        @load="listload_more"
      >
        <div
          v-for="item in list"
          :key="item.id"
          style="margin-bottom: 10px"
          class="main"
          @click="linkid(item.id)"
        >
          <div
            class="tabflexdiv"
            style="font-size: 14px; font-weight: bold; margin: 10px 0"
          >
            <p class="topic">{{ item.title }}</p>
            <img
              style="width: 20px; height: 20px"
              src="//pic-cdn.bigdatajy.com/wenming/static/img/share.png"
              alt=""
              @click.stop="
                showShare = true;
                share(
                  item.title,
                  item.starttime_fmt,
                  item.endtime_fmt,
                  item.range_str,
                  item.address,
                  item.org_name,
                  item.total_count,
                  item.id,
                  item.img
                );
              "
            />
          </div>
          <div class="tabflexdiv">
            <div class="left">
              <div class="picdiv">
                <img :src="item.img" alt="" />
                <!-- 状态标签 -->
                <div
                  class="status"
                  v-show="item.zt == 1"
                  :class="{ active01: item.zt == 1 }"
                >
                  <p>报名中</p>
                </div>
                <div
                  class="status"
                  v-show="item.zt == 2"
                  :class="{ active02: item.zt == 2 }"
                >
                  <p>进行中</p>
                </div>
                <div
                  class="status"
                  v-show="item.zt == 3"
                  :class="{ active03: item.zt == 3 }"
                >
                  <p>已完成</p>
                </div>
                <div
                  class="status"
                  v-show="item.zt == 4"
                  :class="{ active04: item.zt == 4 }"
                >
                  <p>已过期</p>
                </div>
              </div>
              <!-- <div class="tabflexdiv" style="margin-top:10px;">
              <div @click.stop="fan(list,item.id,index)">
                <i v-show="item.fan == 2" class="el-icon-star-off"></i>
                <i v-show="item.fan == 1" class="el-icon-star-on" style="color:red;"></i>
                <span>点击收藏</span>
              </div>
              <div @click.stop="showShare = true;share(item.title,item.starttime_fmt,item.endtime_fmt,item.range_str,item.address,item.org_name,item.total_count,item.id,item.img)">
                <i class="el-icon-position"></i>
                <span>一键转发</span>
              </div>
            </div> -->
            </div>
            <div class="right">
              <p>活动开始时间：</p>
              <p>{{ timeTransevent(item.starttime) }}</p>
              <p>活动范围：{{ item.range_str }}</p>
              <p>发起组织：{{ item.org_name }}</p>
              <p>
                报名人数：{{ item.count
                }}<span v-if="item.total_count">/{{ item.total_count }}</span
                >人
              </p>
              <el-button
                v-show="item.isclose == 0 && item.btn != 0"
                type="primary"
                >{{ item.btn_str }}</el-button
              >
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <!-- 分享面板 -->
    <van-share-sheet
      v-model="showShare"
      title="立即分享给好友"
      :options="options"
      @select="onShareSelect"
    />
    <!-- 分享海报 -->
    <vue-canvas-poster
      :widthPixels="1000"
      :painting="painting"
      @success="success"
      @fail="fail"
    >
    </vue-canvas-poster>
    <van-overlay :show="showposter" @click="showposter = false">
      <img
        class="poster"
        @touchend.prevent="isAndroid && saveimg()"
        saveImage="true"
        :src="posterimg"
        alt=""
      />
    </van-overlay>
  </div>
</template>
<script>
export default {
  name: "eventcenter",
  data() {
    return {
      isAndroid: false,
      status: 0,
      tab: 0,
      list: [],
      top: {},
      listloading: false,
      listfinished: false,
      listpage: 1,
      appId: "2312",
      url: "",
      showPopover: false,
      actions: [
        { text: "发布报告", icon: "notes-o", className: "0" },
        { text: "发布心愿", icon: "exchange", className: "1" },
        { text: "我的收藏", icon: "like-o", className: "2" },
      ],
      search: "",
      member: {},
      showShare: false,
      options: [
        { name: "分享海报", icon: "poster" },
        { name: "其他", icon: "link" },
      ],
      painting: {
        width: `${document.documentElement.clientWidth}px`,
        height: `${document.documentElement.clientWidth * 1.6}px`,
        background: "#fff",
        views: [
          {
            //头像
            type: "image",
            id: "avater",
            url: "",
            css: {
              top: "50px",
              left: `${document.documentElement.clientWidth / 3.1}px`,
              width: `${document.documentElement.clientWidth / 2.8}px`,
              height: `${document.documentElement.clientWidth / 3.5}px`,
            },
          },
          {
            //text1 title
            type: "text",
            text: "",
            css: {
              top: [
                `${document.documentElement.clientWidth / 7 + 20}px`,
                "avater",
              ],
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "20px",
              textAlign: "center",
              maxLines: 1,
            },
          },
          {
            //text2 starttime
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 120}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
            },
          },
          {
            //text3 endtime
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 144}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
            },
          },
          {
            //text4 range
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 168}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
            },
          },
          {
            //text5 address
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 192}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
              maxLines: 1,
            },
          },
          {
            //text6 org
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 216}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
              maxLines: 1,
            },
          },
          {
            //text6 count
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 240}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
            },
          },
          {
            //rect
            type: "rect",
            text: "",
            css: {
              bottom: `100px`,
              width: `${document.documentElement.clientWidth - 40}px`,
              left: "20px",
              height: "1px",
              color: "grey",
            },
          },
          {
            //qrcode
            type: "qrcode",
            content: "",
            css: {
              bottom: "20px",
              width: "60px",
              height: "60px",
              left: "20px",
            },
          },
          {
            //icon
            type: "image",
            url: "",
            css: {
              bottom: "20px",
              right: "20px",
              width: "60px",
              height: "60px",
            },
          },
          {
            //text
            type: "text",
            text: "①长按保存图片到相册",
            css: {
              bottom: "64px",
              width: `${document.documentElement.clientWidth - 180}px`,
              fontSize: "12px",
              left: "90px",
              color: "#a1a1a1",
            },
          },
          {
            //text
            type: "text",
            text: "②打开最江阴APP扫一扫",
            css: {
              bottom: "24px",
              width: `${document.documentElement.clientWidth - 180}px`,
              fontSize: "12px",
              left: "90px",
              color: "#a1a1a1",
            },
          },
        ],
      },
      posterimg: "",
      showposter: false,
      currentshareevent: {},
    };
  },
  created() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    if (isAndroid) {
      this.isAndroid = true;
    }
    var that = this;
    //app
    this.url = "//zhuzhan.ijiangyin.com/siteapp/appClient/sign";
    zjyapi.init({
      appId: that.appId,
      error: function (code, ret) {
        //失败回调,默认
        alert("初始化失败");
      },
      success: function success(ret) {
        console.log("初始化成功");
      },
    });
    window.addEventListener("load", function () {
      zjyapi.saveImage();
    });
    /* 树附近数据 */
    this.$axios({
      method: "post",
      url: "/api/task/index",
    }).then((res) => {
      console.log(res.data);
      if (res.data.code == 0) {
        this.top = res.data.data.count;
      }
    });
    /* 热门推荐 */
    this.initrmtj();
    /* 我的数据 */
    this.$axios({
      method: "post",
      url: "/api/home/index",
    }).then((res) => {
      console.log(res.data);
      if (res.data.code == 0) {
        this.member = res.data.data.member;
        if (this.member.img == "") {
          this.member.img =
            "//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png";
        }
      } else {
        this.queryUserInfoAll();
      }
    });
  },
  methods: {
    saveimg() {
      console.log("调用saveimage");
      zjyapi.saveImage(true);
    },
    changesharepic() {
      this.$axios({
        method: "post",
        url: "/api/common/uploadbaseimg",
        data: this.qs.stringify({
          base_img: this.posterimg,
        }),
      }).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          this.posterimg = res.data.data.url;
          //this.showposter = true;
        } else {
          //this.$toast('生成海报失败，请重试');
        }
      });
    },
    /* poster */
    share(title, starttime, endtime, range, address, org, count, id, img) {
      this.currentshareevent.title = title;
      this.currentshareevent.starttime = starttime;
      this.currentshareevent.endtime = endtime;
      this.currentshareevent.range = range;
      this.currentshareevent.address = address;
      this.currentshareevent.org = org;
      this.currentshareevent.count = count;
      this.currentshareevent.id = id;
      this.currentshareevent.img = img;
    },
    beginPoster() {
      this.$set(this.painting.views[0], "url", this.currentshareevent.img);
      this.$set(this.painting.views[1], "text", this.currentshareevent.title);
      this.$set(
        this.painting.views[2],
        "text",
        "活动开始时间：" + this.currentshareevent.starttime
      );
      this.$set(
        this.painting.views[3],
        "text",
        "活动结束时间：" + this.currentshareevent.endtime
      );
      this.$set(
        this.painting.views[4],
        "text",
        "活动范围：" + this.currentshareevent.range
      );
      this.$set(
        this.painting.views[5],
        "text",
        "活动地址：" + this.currentshareevent.address
      );
      this.$set(
        this.painting.views[6],
        "text",
        "发起组织：" + this.currentshareevent.org
      );
      this.$set(
        this.painting.views[7],
        "text",
        "参与名额：" + this.currentshareevent.count + "人"
      );
      this.$set(
        this.painting.views[9],
        "content",
        "https://www.jywmsj.cn/h5/#/detail?id=" + this.currentshareevent.id
      );
      this.$set(
        this.painting.views[10],
        "url",
        "https://pic-cdn.bigdatajy.com/wenming/static/img/icon3.png"
      );
      this.$toast("生成海报中");
      this.showposter = true;
    },
    success(src) {
      //console.log(src);
      this.posterimg = src;
      this.changesharepic();
    },
    fail(err) {
      console.log("fail", err);
    },
    /* posterend */
    onShareSelect(option) {
      console.log(option);
      switch (option.icon) {
        case "poster":
          console.log("poster");
          this.beginPoster();
          break;
        case "link":
          this.showShare = false;
          this.zhuanfa(
            this.currentshareevent.title,
            this.currentshareevent.id,
            this.currentshareevent.img,
            this.currentshareevent.starttime,
            this.currentshareevent.endtime,
            this.currentshareevent.range
          );
        default:
          break;
      }
      this.showShare = false;
    },
    onSearch() {
      this.initrmtj();
      this.listfinished = false;
      this.list = [];
      this.listpage = 1;
    },
    onSelect(action) {
      console.log(action);
      if (action.className == 0) {
        this.$router.push("/mywishlist");
      }
      if (action.className == 1) {
        this.$router.push("/applywish");
      }
      if (action.className == 2) {
        this.$router.push("/myfav");
      }
    },
    initrmtj() {
      this.listpage = 1;
      this.listfinished = false;
      this.listloading = false;
      this.list = [];
      this.$axios({
        method: "post",
        url: "/api/task/wish_list",
        data: this.qs.stringify({
          keyword: this.search,
        }),
      }).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          this.list = res.data.data.list;
          for (let i in res.data.data.list) {
            this.list[i].fan = 2;
            if (this.list[i].fav) {
              this.list[i].fan = 1;
            }
          }
          this.$forceUpdate();
        }
      });
    },
    zhuanfa(title, id, img, starttime, endtime, address) {
      this.openShare(
        title,
        "https://www.jywmsj.cn/h5/#/detail?id=" + id,
        "https://www.jywmsj.cn/" + img,
        starttime,
        endtime,
        address
      );
    },
    listload_more() {
      this.listpage += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/task/wish_list",
            data: that.qs.stringify({
              keyword: that.search,
              page: that.listpage,
            }),
          })
          .then((res) => {
            console.log(res.data);
            if (res.data.code == 0) {
              for (let i in res.data.data.list) {
                res.data.data.list[i].fan = 2;
                if (res.data.data.list[i].fav) {
                  res.data.data.list[i].fan = 1;
                }
              }
              that.list = that.list.concat(res.data.data.list);
            }
            that.listloading = false;
            if (res.data.data.list.length == 0) {
              //数据全部加载完成
              that.listfinished = true;
            } else {
              that.listfinished = false;
            }
          });
      }, 500);
    },
    linkid(id) {
      this.$router.push({
        name: "detail",
        query: {
          id: id,
        },
      });
    },
    linkto(url) {
      this.$router.push(url);
    },
    urlchange(url) {
      if (url == "/center") {
        if (!sessionStorage.getItem("wmtoken")) {
          this.$toast("请先加入志愿者");
          return;
        }
      }
      this.$router.push(url);
    },
    //收藏
    fan(list, id, index) {
      console.log(index);
      //未收藏状态
      if (list[index].fan == 2) {
        this.$axios({
          method: "post",
          url: "/api/task/fav",
          data: this.qs.stringify({
            task_id: id,
            type: 1,
            token: sessionStorage.getItem("wmtoken"),
          }),
        }).then((res) => {
          console.log(res.data);
          if (res.data.code == 0) {
            list[index].fan = 1;
            this.$forceUpdate();
          } else {
            this.$toast(res.data.msg);
          }
        });
      } else {
        this.$axios({
          method: "post",
          url: "/api/task/fav",
          data: this.qs.stringify({
            task_id: id,
            type: 2,
            token: sessionStorage.getItem("wmtoken"),
          }),
        }).then((res) => {
          console.log(res.data);
          if (res.data.code == 0) {
            list[index].fan = 2;
            this.$forceUpdate();
          } else {
            this.$toast(res.data.msg);
          }
        });
      }
    },
    timeTrans(time) {
      let date = new Date(parseInt(time) * 1000);
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let minute = date.getMinutes();
      let second = date.getSeconds();
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      //console.log( y + '-' + m + '-' + d + ' ' + '　' + h + ':' + minute + ':' + second);
      time = y + "/" + m + "/" + d;
      return time;
    },
    //app相关开始
    //获取签名方法
    getSign: function (fun) {
      /*请求参数*/
      var paramObj = {
        httpUrl: this.url,
        type: "post",
        data: {
          appId: this.appId,
        },
      };
      /*请求调用*/
      this.httpRequest(paramObj, fun, function () {
        alert("获取签名失败错误");
      });
    },
    httpRequest: function (paramObj, fun, errFun) {
      var xmlhttp = null;
      /*创建XMLHttpRequest对象，
       *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
       * */
      if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
      /*判断是否支持请求*/
      if (xmlhttp == null) {
        alert("你的浏览器不支持XMLHttp");
        return;
      }
      /*请求方式，并且转换为大写*/
      var httpType = (paramObj.type || "GET").toUpperCase();
      /*数据类型*/
      var dataType = paramObj.dataType || "json";
      /*请求接口*/
      var httpUrl = paramObj.httpUrl || "";
      /*是否异步请求*/
      var async = paramObj.async || true;
      /*请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
      var paramData = paramObj.data || [];
      var requestData = "";
      for (var name in paramData) {
        requestData += name + "=" + paramData[name] + "&";
      }
      requestData =
        requestData == ""
          ? ""
          : requestData.substring(0, requestData.length - 1);
      console.log(requestData);
      /*请求接收*/
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          /*成功回调函数*/
          //获取签名数据成功:{"serverTime":null,"error":"200","msg":"成功","data":{"appSign":"b37808616bda9d71e100e0971881101d","appId":"2312""timestamp":1575953679723},"map":null}
          console.log("获取签名数据成功:" + xmlhttp.responseText);
          var obj = JSON.parse(xmlhttp.responseText);
          var data = obj.data;
          fun({
            timestamp: data.timestamp,
            sign: data.appSign,
          });
        } else {
          /*失败回调函数*/
          errFun;
        }
      };
      /*接口连接，先判断连接类型是post还是get*/
      if (httpType == "GET") {
        xmlhttp.open("GET", httpUrl, async);
        xmlhttp.send(null);
      } else if (httpType == "POST") {
        xmlhttp.open("POST", httpUrl, async);
        //发送合适的请求头信息
        xmlhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xmlhttp.send(requestData);
      }
    },
    queryUserInfoAll: function () {
      var that = this;
      this.getSign(function (sign) {
        zjyapi.queryUserInfoAll({
          sign: sign,
          params: {
            type: "2",
          },
          success: function (ret) {
            console.log("获取用户信息成功：" + ret);
            var data = JSON.parse(ret);
            if (data.uid) {
              sessionStorage.setItem("uid", data.uid);
            } else {
              alert("请登录app");
            }
            that.member.img =
              "//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png";
            that.member.name = data.authenticationName;
            that.$forceUpdate();
            console.log(ret);
            console.log(JSON.parse(ret));
          },
          error: function (error) {
            console.log("获取用户信息失败：" + JSON.stringify(error));
          },
        });
      });
    },
    openShare: function (title, url, imgUrl, starttime, endtime, address) {
      var that = this;
      this.getSign(function (sign) {
        zjyapi.openShare({
          sign: sign,
          params: {
            title: title,
            content: `
            ${starttime}-${endtime}
            ${address}
            ${title}
            `,
            url: url, //分享地址
            imgUrl: imgUrl, //分享图标地址
          },
          success: function (ret) {
            console.log("分享成功：" + ret);
            var data = JSON.parse(ret);
            console.log(ret);
            console.log(data);
          },
          error: function (error) {
            console.log("分享失败：" + JSON.stringify(error));
          },
        });
      });
    },
    //app相关end
  },
};
</script>
<style scoped>
.container {
  min-height: 100vh;
}
img {
  width: 100%;
  display: block;
}
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  font-size: 12px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  color: #a1a1a1;
  background: #f2f2f2;
}
/* .footer p {
  font-size: 0.289855rem;
} */
.footer div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 20%;
}
.icon {
  width: 20px;
  height: 20px;
}
.font {
  color: white;
  font-size: 14px;
  margin: 5px;
  position: absolute;
  top: 10px;
  left: 10px;
  font-weight: bold;
}
.flex {
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bts {
  width: 90%;
  margin: 0 auto;
  position: relative;
  height: 70px;
  bottom: 80px;
}
.bt {
  color: white;
  position: relative;
  width: 65%;
  right: -36vw;
}
.bt p {
  position: absolute;
  bottom: 6vw;
  text-align: center;
  width: 100%;
}
.right {
  width: 13vw;
}
.tabs {
  width: 80%;
  margin: 0 auto;
  border: 1px solid #f0f2f5;
  background: #f0f2f5;
  color: #303133;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  margin-top: -60px;
  font-size: 14px;
}
.tabs p {
  width: 33%;
  text-align: center;
  line-height: 36px;
}
.active {
  color: red;
  background: white;
}
.tabcontainer {
  padding: 10px;
  margin-bottom: 50px;
}
.tabflexdiv {
  display: flex;
  justify-content: space-between;
}
.left {
  width: 40vw;
  font-size: 3.5vw;
}
.left img {
  height: 32vw;
  object-fit: contain;
}
.tabcontainer .right {
  width: 53%;
  display: flex;
  flex-direction: column;
  line-height: 1.2em;
}
.tabcontainer .right p {
  font-size: 3vw;
}
.tabcontainer .right .el-button {
  width: 60%;
  align-self: flex-end;
  padding: 10px;
  margin-top: auto;
}
.main {
  border-top: 5px solid #fd9292;
  padding: 0 10px 10px 10px;
  background-color: rgba(255, 250, 247, 100);
  color: rgba(16, 16, 16, 100);
  box-shadow: 0px 2px 6px 0px rgba(155, 150, 113, 38);
}
.label {
  background: #a5ef99;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  padding: 3px 10px;
  margin-right: -11px;
  white-space: nowrap;
  height: 20px;
  line-height: 20px;
}
.picdiv {
  position: relative;
  overflow: hidden;
}
.status {
  font-size: 12px;
  color: white;
  font-weight: bold;
  background: orange;
  text-align: center;
  position: absolute;
  top: 13%;
  left: -33%;
  width: 100%;
  padding: 2px;
  transform: rotate(-45deg);
}
.active01 {
  background: orange;
}
.active02 {
  background: #7dce86;
}
.active03 {
  background: #f26161;
}
.active04 {
  background: grey;
}
.topic {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.block {
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  margin-top: -95px;
}
.block > div {
  display: flex;
  align-items: center;
  flex-direction: column;
  color: #cab586;
  font-size: 14px;
}
.centericon {
  margin: auto;
  width: 50%;
  height: 50%;
  display: block;
}
.cover {
  width: 15vw;
  height: 15vw;
  background: #cab586;
  border-radius: 50%;
  margin: 10px auto;
  display: flex;
}
.tx {
  margin: 10px;
  width: 25vw;
  height: 25vw;
  border-radius: 5px;
  object-fit: cover;
  border: 2px solid #cab586;
  background: white;
}
.poster {
  width: 80%;
  border-radius: 10px;
  margin: auto;
  margin-top: 10vw;
  -webkit-touch-callout: default;
}
.eventrule {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #cab586;
  font-size: 14px;
  font-weight: bold;
}
.eventrule img {
  width: 30px;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/eventcenter.vue